import { Controller } from 'stimulus'
import swal from 'sweetalert2'

export default class extends Controller {
	show(event) {
    let toastText = event.target.dataset.text
    let toastTitle = event.target.dataset.title
    const Toast = swal.mixin()
    Toast.fire({
      icon: 'info',
      title: toastTitle,
      text: toastText
    })
  }
}
